import React from 'react';
import { ArrayHelper } from 'foundation/helpers';
import { ProductCard } from 'shared/product-card';

const ProductListCards = ({ products }) => {
    if (ArrayHelper.isEmpty(products)) return null;

    return (
        <div className="product-list-cards grid" aria-live="polite">
            <ul className="product-list-cards__list row">
                {
                    products
                        .map((product) => {
                            const model = {
                                id: product.id,
                                name: product.name,
                                url: product.linkUrl,
                                image: product.primaryImage,
                                prices: product.prices,
                                label: product.status,
                                trackingProduct: product.trackingProduct
                            };
                            return (
                                <li className="product-list-cards__col col col-xs-12 col-sm-4 col-md-3" key={model.id}>
                                    <ProductCard model={model} />
                                </li>
                            );
                        })
                }
            </ul>
        </div>
    );
};

export default ProductListCards;
